module.exports = __webpack_public_path__ + "images/adbe477810664b8ed90866aeb9f32f18.png";